import { render } from "./svg-star-half.vue?vue&type=template&id=6a2d6490"
import script from "./svg-star-half.vue?vue&type=script&lang=ts"
export * from "./svg-star-half.vue?vue&type=script&lang=ts"
script.render = render

export default script